import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
import Icon from '../Icon/Icon';
function ArrowButton({ className, variant, disabled = false, children }) {
    return children({
        className: clsx('cursor-pointer backdrop-blur-sm flex items-center justify-center transition-colors duration-300 ease-in-out', 
        // Sizing
        'w-1.75 md:w-2 aspect-square', 
        // Colours
        'light:bg-ui-specific-glass-light-40 light:text-symbol-primary light:hover:bg-surface-expressive light:hover:text-symbol-contrast', 'dark:bg-ui-specific-glass-light-40 dark:text-symbol-contrast dark:hover:bg-surface-hover', 
        // Active
        'focus-visible:outline-solid focus-visible:outline-1 focus-visible:outline-offset-2', 'light:focus-visible:outline-border-primary dark:focus-visible:outline-border-contrast', 
        // Disabled
        disabled && 'cursor-default pointer-events-none opacity-50', className),
        inert: disabled ? '' : undefined,
        'aria-disabled': disabled,
        icon: _jsx(Icon, { variant: variant, className: "aspect-square w-[14px] md:w-1.5" }),
    });
}
export default ArrowButton;
